import { combineReducers } from 'redux';
import user from './user';
import session from './session';
import ticket from './ticket';

export default combineReducers({ user, session, ticket });
